module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNi40IiB2aWV3Qm94PSIwIDAgMTggMTYuNCI+CiAgICA8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIycHgiIGQ9Ik0xOCAzSDJsNi40IDcuNTY4VjE1LjhsMy4yIDEuNnYtNi44MzJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMSAtMikiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter.svg
// module id = PSza
// module chunks = 1